import { db } from '../../utils/firebase';

// get all robots
export const getAllRobots = async () => {
  const robots = [];
  const querySnapshot = await db.collection("robots").get();

  const promises = [];
  querySnapshot.forEach(doc => {
    // doc.data() is never undefined for query doc snapshots
    const { title, order } = doc.data();
    // get children for each section
    promises.push(
      db
        .collection("robots")
        .doc(title)
        .collection("children")
        .get()
    );
    robots.push({ title, order, children: [] });
  });

  // push all childrens to robots
  const snapshots = await Promise.all(promises);
  let i = 0;
  snapshots.forEach(querySnapshot1 => {
    const childrens = [];
    querySnapshot1.forEach(doc => {
      // get single children
      let { name: subtitle, images: image, content } = doc.data();
      if (!subtitle) subtitle = "";
      if (!image) image = [];
      if (!content) content = "";
      childrens.push({ subtitle, image, content });
    });
    robots[i].children = childrens.reverse();
    i++;
  });

  // sort each section in order
  robots.sort((a, b) => a.order - b.order);

  return robots;
}